import React from 'react';

const CancelBooking = () => {
  const handleCancellation = () => {
    // Placeholder for cancellation logic
    console.log('Booking Cancelled');
  };

  return (
    <div className="p-4 bg-white shadow-md rounded-lg">
      <h1 className="text-lg font-bold">Cancel Booking</h1>
      <p>Are you sure you want to cancel your booking?</p>
      <button onClick={handleCancellation} className="bg-red-500 text-white p-2 rounded mt-2">
        Confirm Cancellation
      </button>
    </div>
  );
};

export default CancelBooking;
